import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43314432"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "shadow" }, null, -1))

import { computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { useRtfix, useSite2Station, isKO, isJA, useSite } from '@/store'
import { Site } from '@/common/const'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const stationCode = useSite2Station()
const store = useStore()
const router = useRouter()
const visible = computed({
  get () {
    return store.state.extension.visible
  },
  set (v) {
    store.commit('extension/visible', v)
  }
})
const imgs = isKO() ? [
  require('@/assets/image/plugin/Kr-plugin1.png'),
  require('@/assets/image/plugin/Kr-plugin2.png'),
  require('@/assets/image/plugin/Kr-plugin-btn.png')
] : isJA() ? [
  require('@/assets/image/plugin1.png'),
  require('@/assets/image/plugin2.png'),
  require('@/assets/image/plugin-btn.png')
] : [
  require('@/assets/image/plugin/en-plugin1.png'),
  require('@/assets/image/plugin/en-plugin2.png'),
  require('@/assets/image/plugin/en-plugin-btn.png')
]

const loadImg = (src: any) => new Promise((resolve) => {
  const img = new Image()
  img.src = src
  img.onload = resolve
})

imgs.map(loadImg)

const handleClick = () => {
  if (isKO()) {
    window.open('https://www.theckbkorea.com/%EA%B5%AC%EB%A7%A4-%EC%A3%BC%EC%9D%98%EC%82%AC%ED%95%AD')
  } else {
    router.push(useRtfix('iframe', { params: { name: 'plugin' } }))
  }
  visible.value = false
}
const close = () => {
  store.commit('extension/hasRemind', true)
}

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "custom-class": "plugin-modal",
    modelValue: _unref(visible),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null)),
    width: "400px",
    onClosed: close
  }, {
    default: _withCtx(() => [
      _createElementVNode("img", {
        referrerPolicy: "no-referrer",
        class: "bg",
        src: _unref(imgs)[0],
        alt: ""
      }, null, 8, _hoisted_1),
      _createElementVNode("img", {
        referrerPolicy: "no-referrer",
        class: _normalizeClass(["plu-btn", _unref(useSite)()]),
        src: _unref(imgs)[2],
        alt: "",
        onClick: handleClick
      }, null, 10, _hoisted_2),
      _hoisted_3
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})